module.exports = __webpack_public_path__ + "img/l3.a1fc40ba.png";